module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.1753a051.ttf";